import { render, staticRenderFns } from "./above.vue?vue&type=template&id=9b7cc43a&scoped=true"
import script from "./above.vue?vue&type=script&lang=js"
export * from "./above.vue?vue&type=script&lang=js"
import style0 from "./above.vue?vue&type=style&index=0&id=9b7cc43a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7cc43a",
  null
  
)

export default component.exports